import { Box } from "@mui/material";
import { IN_REPAIR_BADGE_BASE_SX, IN_REPAIR_PRIORITY_STYLES } from "../data/inRepairListingConstants";

const InRepairPriorityBadge = ({ tier }) => {
  if (!tier) return null;

  const style = IN_REPAIR_PRIORITY_STYLES[tier] || IN_REPAIR_PRIORITY_STYLES.P5;

  return (
    <Box
      component="span"
      sx={{
        ...IN_REPAIR_BADGE_BASE_SX,
        backgroundColor: style.bg,
        color: style.color,
      }}
    >
      {tier}
    </Box>
  );
};

export default InRepairPriorityBadge;
